import React from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "../../components/Navigation/Sidebar/Sidebar";
import TopMenu from "../../components/Navigation/TopMenu/TopMenu";
import styled from "styled-components";

export default function AuthenticatedApp() {
    return (
        <>
            <TopMenu />
            <AppContainer>
                <Sidebar /> {/* Render only once here! */}
                <MainContent>
                    <Outlet />
                </MainContent>
            </AppContainer>
        </>
    );
}

const AppContainer = styled.div`
    display: flex;
    height: 100vh;
`;

const MainContent = styled.div`
    flex-grow: 1;
    padding: 20px;
    padding-top: 80px;
    overflow-y: auto;
    min-height: 100vh;
    background: #f6f9fb;
    margin-left: 0;

    @media (min-width: 768px) {
        margin-left: 250px; /* Sidebar width */
    }
`;
